import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Video, Videotape, Settings, Tag, Folder, Clapperboard } from 'lucide-react';

const menuItems = [
    { name: 'Home', path: '/', icon: Home },
    { name: 'VeoMate Studio', path: '/studio', icon: Video },
    { name: 'Settings', path: '/settings', icon: Settings },
];

const Sidebar = () => {
    const location = useLocation();

    return (
        <div className="w-72 p-4 flex flex-col bg-gray-100">
            <div className="mb-8 flex items-center">
                <Clapperboard className="w-8 h-8 mr-2 text-blue-600" />
                <h2 className="text-xl font-bold text-gray-800 dark:text-gray-200">LumenFind</h2>
            </div>
            <ul className="space-y-2">
                {menuItems.map((item) => {
                    const isSelected = location.pathname === item.path;
                    const Icon = item.icon;
                    const iconClass = `w-6 h-6 transition duration-75 group-hover:text-gray-900 dark:group-hover:text-white ${isSelected ? 'text-white' : 'text-gray-500 dark:text-gray-400'
                        }`;

                    return (
                        <li key={item.name}>
                            <Link
                                to={item.path}
                                className={`group flex items-center p-2 text-base font-normal rounded-lg w-full transition-colors ${isSelected
                                        ? 'bg-blue-600 text-white'
                                        : 'text-gray-900 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700'
                                    }`}
                            >
                                <Icon className={iconClass} />
                                <span className="ml-3">{item.name}</span>
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default Sidebar;